<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ControlMenu from './ControlMenu.vue'
import { storeToRefs } from 'pinia'
import ExportToSpeckleDialog from '@/components/speckle/ExportToSpeckleDialog.vue'
import { useProjectSpeckleStore } from '@/store/projectSpeckle'
import ConnectToSpeckleDialog from '@/components/speckle/ConnectToSpeckleDialog.vue'

defineProps({
  showEdit: { type: Boolean, default: false }
})

const store = useStore()
const projectSpeckleStore = useProjectSpeckleStore()

const { writeLoading: speckleLoading, exportToSpeckleDialog } = storeToRefs(projectSpeckleStore)

const loading = computed(() => store.state.project.loading)
const showElevationProfiles = computed(() => store.state.dikeProfiles.showElevationProfiles)

const toggleShowElevationProfiles = (val) =>
  store.dispatch('dikeProfiles/toggleShowElevationProfiles', val)

const toggleEdit = () => store.dispatch('project/toggleEdit')

const setEdit = () => {
  toggleEdit()
  toggleShowElevationProfiles(false)
}
</script>

<template>
  <v-card flat class="mb-2">
    <v-card-title>
      <div class="d-flex align-center">
        <div>Dike trajectory</div>

        <v-btn v-if="showEdit" size="32" icon="mdi-pencil" variant="plain" @click="setEdit">
          <v-icon color="grey-darken-2" size="small">mdi-pencil</v-icon>
        </v-btn>

        <v-btn
          @click="exportToSpeckleDialog = true"
          class="text-none mx-1"
          prepend-icon="mdi-tray-arrow-up"
          variant="tonal"
          :loading="speckleLoading && !exportToSpeckleDialog"
        >
          Send to Speckle
        </v-btn>
        <v-btn
          @click="toggleShowElevationProfiles(!showElevationProfiles)"
          class="text-none mx-1"
          prepend-icon="mdi-chart-timeline-variant"
          variant="tonal"
        >
          Elevation profiles
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="!loading">Please create or select a schematisation. </v-card-subtitle>
    <v-card-subtitle v-if="!loading" class="pt-0">
      Click on the chips in front of the dike section or profile to fly to the location.
    </v-card-subtitle>
    <v-card-subtitle v-else>Loading...</v-card-subtitle>
    <ControlMenu class="my-2" />
    <ExportToSpeckleDialog />
    <ConnectToSpeckleDialog />
  </v-card>
</template>
